import {
  FETCH_SHIFTS_REQUEST, FETCH_SHIFTS_SUCCESS, FETCH_SHIFTS_FAILURE,
  CREATE_SHIFT_REQUEST, CREATE_SHIFT_SUCCESS, CREATE_SHIFT_FAILURE,
  UPDATE_SHIFT_REQUEST, UPDATE_SHIFT_SUCCESS, UPDATE_SHIFT_FAILURE,
  DELETE_SHIFT_REQUEST, DELETE_SHIFT_SUCCESS, DELETE_SHIFT_FAILURE
} from "../actions/shiftActions";

const initialState = {
  shifts: [],
  loading: false,
  creating: false,
  error: null,
  success: false,
};

const shiftReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SHIFTS_REQUEST:
    case UPDATE_SHIFT_REQUEST:
    case DELETE_SHIFT_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case CREATE_SHIFT_REQUEST:
      return { ...state, creating: true, error: null, success: false };

    case FETCH_SHIFTS_SUCCESS:
      return { ...state, loading: false, success: false, shifts: action.payload };

case CREATE_SHIFT_SUCCESS:
  return {
    ...state,
    creating: false,
    success: true,

  };

      return { ...state, creating: false, success: true, shifts: [...state.shifts, action.payload] };

    case UPDATE_SHIFT_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        shifts: state.shifts.map((s) => (s.id === action.payload.id ? action.payload : s)),
      };

    case DELETE_SHIFT_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        shifts: state.shifts.filter((s) => s.id !== action.payload),
      };

    case FETCH_SHIFTS_FAILURE:
    case UPDATE_SHIFT_FAILURE:
    case DELETE_SHIFT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case CREATE_SHIFT_FAILURE:
      return { ...state, creating: false, error: action.payload };

    default:
      return state;
  }
};

export default shiftReducer;